import * as React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';

import { Offer, OfferCategory } from '../../../graphql/API';
import Stepper from './Stepper';
import Step1 from './components/Step1';
import Step2 from './components/Step2';
import SuccessBuy from './components/SuccessBuy';
import { useCreateInvite } from './context/CreateInvite.context';
import { CreateInviteProviderProps } from './context/CreateInvite.provider';
import { Step } from './context/types';

type StepPanelProps = {
  step: number;
  offer?: Offer;
  handleUserDeletion?: CreateInviteProviderProps['handleUserDeletion'];
};

const StepPanel: React.FC<StepPanelProps> = ({ step, handleUserDeletion }) => {
  switch (step) {
    case Step.OfferSelection:
      return <Step1 />;
    case Step.Summary:
      return <Step2 handleUserDeletion={handleUserDeletion} />;
  }
  return null;
};

type Props = {
  onClose?: () => void;
  modalRef?: CreateInviteProviderProps['modalRef'];
  handleInviteStep?: (val: number, offerCategory?: OfferCategory) => void;
  handleUserDeletion?: CreateInviteProviderProps['handleUserDeletion'];
};

const CreateInvite: React.FC<Props> = ({ onClose, modalRef, handleInviteStep, handleUserDeletion }) => {
  const { state, dispatch } = useCreateInvite();

  React.useEffect(() => {
    if (handleInviteStep) {
      handleInviteStep(state.step, state.offer?.category);
    }
  }, [handleInviteStep, state.offer?.category, state.step]);

  if (state.step === Step.Success) {
    return <SuccessBuy modalRef={modalRef} onClose={onClose} />;
  }

  return (
    <Box>
      <Stepper activeStep={state.step} offer={state.offer} />
      {state.step > 0 && (
        <IconButton
          aria-label='delete'
          size='medium'
          color='primary'
          onClick={() => {
            dispatch({ type: 'prev' });
          }}
          sx={(theme) => ({
            position: 'absolute',
            top: theme.spacing(1),
            left: theme.spacing(2.5),
          })}
        >
          <ArrowBackIcon fontSize='inherit' />
        </IconButton>
      )}

      <StepPanel step={state.step} offer={state.offer} handleUserDeletion={handleUserDeletion} />
    </Box>
  );
};

export default CreateInvite;
